<div class="absolute inset-0 flex flex-col min-w-0 overflow-hidden">

    <div class="flex sm:flex-row flex-0 sm:items-center sm:justify-between p-6 pb-22 sm:pt-12 sm:pb-28 sm:px-10 bg-default dark:bg-transparent">
        <div class="flex-1 min-w-0">
            <div>
                <div class="flex">
                    <a class="inline-flex items-center -ml-1.5 text-secondary font-medium" [routerLink]="'/community-list'">
                        <mat-icon class="icon-size-5 text-secondary" [svgIcon]="'heroicons_solid:chevron-left'"></mat-icon>
                        <span class="ml-1">Back</span>
                    </a>
                </div>
            </div>
            <div class="mt-2">
                <h2 class="text-3xl md:text-4xl font-extrabold tracking-tight leading-7 sm:leading-10 truncate">
                    {{ isEditMode ? 'Edit Community' : 'Community Details' }}
                </h2>
            </div>
        </div>
        <div class="flex shrink-0 items-center mt-6 sm:mt-0 sm:ml-4">
            <button *ngIf="!isEditMode" class="px-8" mat-raised-button color="primary" 
                    (click)="toggleEditMode()">
                Edit
            </button>
        </div>
    </div>

    <div class="flex-auto -mt-16 p-6 sm:p-10 rounded-t-2xl shadow overflow-y-auto bg-card" cdkScrollable>

        <!-- Form View -->
        <form *ngIf="isEditMode" class="p-4 bg-card shadow rounded overflow-hidden" [formGroup]="communityForm" #communityFormNgForm="ngForm" (ngSubmit)="onFormSubmit()">
            <div class="flex flex-0 flex-col sm:flex-row sm:items-center sm:justify-between">
                <!-- <div class="text-2xl md:text-3xl font-extrabold tracking-tight leading-7 sm:leading-10 truncate">
                    Community Information
                </div> -->
            </div>

            <div class="my-5 border-t"></div>

            <div class="grid sm:grid-cols-12 gap-6 w-full mt-8">
                <div class="sm:col-span-6">
                    <mat-form-field class="w-full">
                        <mat-label>Community Name</mat-label>
                        <input matInput formControlName="name" required>
                        <mat-error *ngIf="communityForm.get('name').invalid">
                            Name is required
                        </mat-error>
                    </mat-form-field>
                </div>

                <div class="sm:col-span-6">
                    <mat-form-field class="w-full">
                        <mat-label>Description</mat-label>
                        <textarea matInput formControlName="description" rows="3"></textarea>
                    </mat-form-field>
                </div>

                <div class="sm:col-span-6">
                    <mat-form-field class="w-full">
                        <mat-label>Location</mat-label>
                        <input matInput formControlName="location" required>
                        <mat-error *ngIf="communityForm.get('location').invalid">
                            Location is required
                        </mat-error>
                    </mat-form-field>
                </div>

                <div class="sm:col-span-6">
                    <mat-form-field class="w-full">
                        <mat-label>Phone</mat-label>
                        <input matInput formControlName="contactPhone" 
                                required>
                        <mat-error *ngIf="communityForm.get('contactPhone').invalid">
                            Phone is required
                        </mat-error>
                    </mat-form-field>
                </div>
            </div>

            <div class="text-center mt-8">
                <button type="button" (click)="toggleEditMode()"
                        mat-raised-button class="mr-2">
                    Cancel
                </button>
                <button type="submit" [disabled]="communityForm.invalid || pageLoader"
                        mat-raised-button color="primary">
                    <span *ngIf="!pageLoader">Update</span>
                    <span *ngIf="pageLoader">Updating...</span>
                </button>
            </div>
        </form>

        <!-- Details View -->
        <div *ngIf="!isEditMode" class="p-6 sm:p-10">
            <!-- <div class="flex flex-0 flex-col sm:flex-row sm:items-center sm:justify-between mb-6">
                <div class="text-2xl md:text-3xl font-extrabold tracking-tight leading-7 sm:leading-10 truncate">
                    Community Information
                </div>
            </div> -->

            <!-- <div class="my-5 border-t"></div> -->

            <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 mt-6">
                <div class="p-4 rounded-lg">
                    <label class="block text-md font-bold text-gray-900 mb-1">Community Name</label>
                    <p class="text-lg text-gray-600">{{ community?.Name || '--' }}</p>
                </div>
                
                <div class="p-4 rounded-lg">
                    <label class="block text-md font-bold text-gray-900 mb-1">Description</label>
                    <p class="text-lg text-gray-600">{{ community?.Community_Description__c || '--' }}</p>
                </div>
              
                <div class="p-4 rounded-lg">
                    <label class="block text-md font-bold text-gray-900 mb-1">Location</label>
                    <p class="text-lg text-gray-600">{{ community?.Community_Location__c || '--' }}</p>
                </div>
              
                <div class="p-4 rounded-lg">
                    <label class="block text-md font-bold text-gray-900 mb-1">Phone</label>
                    <p class="text-lg text-gray-600">{{ community?.Community_Phone__c || '--' }}</p>
                </div>
                <div class="p-4 rounded-lg">
                    <label class="block text-md font-bold text-gray-900 mb-1">Created By</label>
                    <p class="text-lg text-gray-600">{{ adminData || '--' }}</p>
                </div>
            </div>
        </div>

        <!-- <div class="loaderMain" *ngIf="pageLoader === true">
            <div>
                <img src="assets/TrailFusion/Trail-Fusion-logo.jpg" class="LoaderImage">
                <p class="loaderText">{{pageLoaderText}}</p>
            </div>
        </div> -->
    </div>
</div>